export default __webpack_public_path__ + "static/media/bg-multi.43aa3d4b.jpg";